import {CP, IP} from "../setting/initParam";
import {
    calcCountInLength,
    calcSegmentsWithPoints, createDefaultMaterial, CutPlane,
    InitialStruct,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct,
    simpleSize, updatePosX, updatePosY, updatePosZ, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";

export async function getHarness(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {
    const lang = new URLSearchParams(window.location.search).get('lang') as 'en'|'de'|'ru' || 'en';

    const countInLength = calcCountInLength(
        CP.maps.pillar.line,
        [[0, 0], [s.l, 0]],
        IP.elementData.harness.sizeBoard.minL,
        IP.elementData.harness.sizeBoard.maxL,
        0,
        0,
    )
    CP.maps.harness.segments = countInLength.segments

    let j = 1
    let rs: RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())
    const nameGroup = IP.elementData.harness.groupName || 'harness'
    const nameElement = IP.elementData.harness.name || 'harness'
    rs.group = nameGroup
    const numGroups = rs.group.length

    const segmentsWithPoints = calcSegmentsWithPoints(
        countInLength.segments,
        CP.maps.pillar.lineCut,
        CP.maps.f1.lineCut
    )

    const Z = s.w / 2
    const Y = s.h - IP.gash.simple + sBoard.h / 2
    for (let i = 0; i < segmentsWithPoints.length; i++) {
        const segment = segmentsWithPoints[i]

        const complexCutsL = []
        const complexCutsR = []
        for (const point of segment.points) {
            if (point.kind === "complexCut") {
                const cutsL = []
                const cutsR = []
                const cutB =
                    {
                        gash: IP.gash.simple,
                        width: IP.elementData.pillar.sizeBoard.w,
                        plane: CutPlane.Bottom
                    }
                cutsL.push(cutB,
                    {
                        gash: IP.gash.cut,
                        width: IP.elementData.f1.sizeBoard.w,
                        plane: CutPlane.Right
                    })
                cutsR.push(cutB,
                    {
                        gash: IP.gash.cut,
                        width: IP.elementData.f1.sizeBoard.w,
                        plane: CutPlane.Left
                    })
                complexCutsL.push({
                    point1: point.point1,
                    point2: point.point2,
                    cuts: cutsL,
                })
                complexCutsR.push({
                    point1: point.point1,
                    point2: point.point2,
                    cuts: cutsR,
                })
            }
        }

        const paramsGetSimpleBoardLeft: ParamsGetSimpleBoard = {
            modeBuild: modeBuild,
            shift: {back: 0, front: 0},
            sizeBoard: {w: sBoard.w, h: sBoard.h, l: segment.length},
            complexCuts: complexCutsL,
        }
        const paramsGetSimpleBoardRight: ParamsGetSimpleBoard = {
            modeBuild: modeBuild,
            shift: {back: 0, front: 0},
            sizeBoard: {w: sBoard.w, h: sBoard.h, l: segment.length},
            complexCuts: complexCutsR,
        }
        if (i === 0 && paramsGetSimpleBoardLeft.shift) {
            paramsGetSimpleBoardLeft.shift.front = s.e.front
        }

        if (i === CP.maps.harness.segments.length - 1 && paramsGetSimpleBoardLeft.shift) {
            paramsGetSimpleBoardLeft.shift.back = s.e.back
        }
        if (i === 0 && paramsGetSimpleBoardRight.shift) {
            paramsGetSimpleBoardRight.shift.front = s.e.front
        }

        if (i === CP.maps.harness.segments.length - 1 && paramsGetSimpleBoardRight.shift) {
            paramsGetSimpleBoardRight.shift.back = s.e.back
        }

        const resultGetSimpleBoardL = await api.getSimpleBoard.build(paramsGetSimpleBoardLeft)
        rs.uvs.push(resultGetSimpleBoardL.mesh.uvs)
        let numUvs = rs.uvs.length - 1
        rs.indices.push(resultGetSimpleBoardL.mesh.indices)
        let numIndices = rs.indices.length - 1
        rs.vertices.push(resultGetSimpleBoardL.mesh.vertices)
        let numVertices = rs.vertices.length - 1
        const specIDL = nameElement+'_i'
        const specIDR = nameElement+'_i'

        const meta = resultGetSimpleBoardL.meta

        const rotation: Vec3 = [-Math.PI/2,0,Math.PI/2]

        const X = 0 - s.e.back / 2 + s.e.front / 2

        let positionL:Vec3 = [0,0,0]
        positionL = updatePosY(positionL, Y)
        positionL = updatePosX(positionL, X)
        const positionR = updatePosZ(positionL, -Z + sBoard.w / 2)
        positionL = updatePosZ(positionL, Z - sBoard.w / 2)

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${j}`,
            nameGroup: nameGroup,
            position: positionL,
            rotation: rotation,
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specIDL,
        }
        rs.elements.push(boardL)

        const resultGetSimpleBoardR = await api.getSimpleBoard.build(paramsGetSimpleBoardRight)
        rs.uvs.push(resultGetSimpleBoardR.mesh.uvs)
        numUvs = rs.uvs.length - 1
        rs.indices.push(resultGetSimpleBoardR.mesh.indices)
        numIndices = rs.indices.length - 1
        rs.vertices.push(resultGetSimpleBoardR.mesh.vertices)
        numVertices = rs.vertices.length - 1

        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${j+1}`,
            nameGroup: nameGroup,
            position: positionR,
            rotation: rotation,
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specIDR,
        }
        rs.elements.push(boardR)

        j += 2
        spec.push({
            w: resultGetSimpleBoardL.meta.w,
            h: resultGetSimpleBoardL.meta.h,
            l: resultGetSimpleBoardL.meta.l,
            name: nameElement,
            group: nameGroup,
            count: 1,
            materialId: IP.elementData.harness.materialId,
            specId: specIDL,
        },{
            w: resultGetSimpleBoardR.meta.w,
            h: resultGetSimpleBoardR.meta.h,
            l: resultGetSimpleBoardR.meta.l,
            name: nameElement,
            group: nameGroup,
            count: 1,
            materialId: IP.elementData.harness.materialId,
            specId: specIDR,
        },)
        specIds.push(specIDR, specIDL)
    }
    rs.specIds = specIds

    return {rs: rs, spec: spec}
}

